import {HOST_MEDIA_URL} from "../redux/api";
import defaultUserLogo from '../assets/images/user_avatar.png';
import defaultLogo from '../assets/images/empty_img.jpg';

export function generateUserImageMediaUrl(path) {
    if (path?.startsWith('http')){
        return path;
    }
    return path ? `${HOST_MEDIA_URL}/images${path}` : defaultUserLogo;
}
export function generateImageMediaUrl(path) {
    if (path?.startsWith('http')){
        return path;
    }
    return path ? `${HOST_MEDIA_URL}/resources${path}` : defaultLogo;
}

export function generateFileMediaUrl(path) {
    if (path?.startsWith('http')){
        return path;
    }
    return path ? `${HOST_MEDIA_URL}/resources${path}` : defaultLogo;
}
